export default {"src":"/_next/static/media/NewSiteIcon.c6453453.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};